var _g, _g2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouthActiveService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5601 3H14.5501C13.7714 3 13.1401 3.63128 13.1401 4.41V8.86C13.1401 9.63872 13.7714 10.27 14.5501 10.27H17.5601C18.3389 10.27 18.9701 9.63872 18.9701 8.86V4.41C18.9701 3.63128 18.3389 3 17.5601 3Z",
    fill: "url(#paint0_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 3H4.66C3.88128 3 3.25 3.63128 3.25 4.41V8.86C3.25 9.63872 3.88128 10.27 4.66 10.27H7.67C8.44872 10.27 9.08 9.63872 9.08 8.86V4.41C9.08 3.63128 8.44872 3 7.67 3Z",
    fill: "url(#paint1_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5601 13.1797H14.5501C13.7714 13.1797 13.1401 13.811 13.1401 14.5897V19.0397C13.1401 19.8184 13.7714 20.4497 14.5501 20.4497H17.5601C18.3389 20.4497 18.9701 19.8184 18.9701 19.0397V14.5897C18.9701 13.811 18.3389 13.1797 17.5601 13.1797Z",
    fill: "url(#paint2_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 13.1797H4.66C3.88128 13.1797 3.25 13.811 3.25 14.5897V19.0397C3.25 19.8184 3.88128 20.4497 4.66 20.4497H7.67C8.44872 20.4497 9.08 19.8184 9.08 19.0397V14.5897C9.08 13.811 8.44872 13.1797 7.67 13.1797Z",
    fill: "url(#paint3_linear_4820_1656)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5201 10.34C16.5201 10.34 16.5901 10.27 16.6201 10.24C15.4701 10.11 14.6001 9.46 14.6001 8.69V4.58C14.6001 3.71 15.7001 3 17.0601 3H15.6001C14.2401 3 13.1401 3.71 13.1401 4.58V8.69C13.1401 9.56 14.2401 10.27 15.6001 10.27H16.5201V10.34Z",
    fill: "url(#paint4_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63 10.34C6.63 10.34 6.7 10.27 6.73 10.24C5.58 10.11 4.71 9.46 4.71 8.69V4.58C4.71 3.71 5.81 3 7.17 3H5.71C4.35 3 3.25 3.71 3.25 4.58V8.69C3.25 9.56 4.35 10.27 5.71 10.27H6.63V10.34Z",
    fill: "url(#paint5_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5201 20.5197C16.5201 20.5197 16.5901 20.4497 16.6201 20.4197C15.4701 20.2897 14.6001 19.6397 14.6001 18.8697V14.7597C14.6001 13.8897 15.7001 13.1797 17.0601 13.1797H15.6001C14.2401 13.1797 13.1401 13.8897 13.1401 14.7597V18.8697C13.1401 19.7397 14.2401 20.4497 15.6001 20.4497H16.5201V20.5197Z",
    fill: "url(#paint6_linear_4820_1656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63 20.5197C6.63 20.5197 6.7 20.4497 6.73 20.4197C5.58 20.2897 4.71 19.6397 4.71 18.8697V14.7597C4.71 13.8897 5.81 13.1797 7.17 13.1797H5.71C4.35 13.1797 3.25 13.8897 3.25 14.7597V18.8697C3.25 19.7397 4.35 20.4497 5.71 20.4497H6.63V20.5197Z",
    fill: "url(#paint7_linear_4820_1656)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8301 3H14.7201C13.8475 3 13.1401 3.70739 13.1401 4.58V8.69C13.1401 9.56261 13.8475 10.27 14.7201 10.27H18.8301C19.7027 10.27 20.4101 9.56261 20.4101 8.69V4.58C20.4101 3.70739 19.7027 3 18.8301 3Z",
    stroke: "url(#paint8_linear_4820_1656)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94 3H4.83C3.95739 3 3.25 3.70739 3.25 4.58V8.69C3.25 9.56261 3.95739 10.27 4.83 10.27H8.94C9.81261 10.27 10.52 9.56261 10.52 8.69V4.58C10.52 3.70739 9.81261 3 8.94 3Z",
    stroke: "url(#paint9_linear_4820_1656)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8301 13.1797H14.7201C13.8475 13.1797 13.1401 13.8871 13.1401 14.7597V18.8697C13.1401 19.7423 13.8475 20.4497 14.7201 20.4497H18.8301C19.7027 20.4497 20.4101 19.7423 20.4101 18.8697V14.7597C20.4101 13.8871 19.7027 13.1797 18.8301 13.1797Z",
    stroke: "url(#paint10_linear_4820_1656)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94 13.1797H4.83C3.95739 13.1797 3.25 13.8871 3.25 14.7597V18.8697C3.25 19.7423 3.95739 20.4497 4.83 20.4497H8.94C9.81261 20.4497 10.52 19.7423 10.52 18.8697V14.7597C10.52 13.8871 9.81261 13.1797 8.94 13.1797Z",
    stroke: "url(#paint11_linear_4820_1656)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 18.9701,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 18.9701,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 18.9701,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 18.9701,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4820_1656",
    x1: 3.25,
    y1: 11.7598,
    x2: 17.0601,
    y2: 11.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4820_1656",
    x1: 3.25,
    y1: 11.7598,
    x2: 17.0601,
    y2: 11.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4820_1656",
    x1: 3.25,
    y1: 11.7598,
    x2: 17.0601,
    y2: 11.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4820_1656",
    x1: 3.25,
    y1: 11.7598,
    x2: 17.0601,
    y2: 11.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 20.4101,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 20.4101,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 20.4101,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4820_1656",
    x1: 3.25,
    y1: 11.7248,
    x2: 20.4101,
    y2: 11.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthActiveService);
export default __webpack_public_path__ + "static/media/youthActiveService.fcc88b43c550b7a1a3a70b785f3edf7d.svg";
export { ForwardRef as ReactComponent };